import axios, { AxiosResponse } from 'axios';
import { authFetch } from '.';
import { IDropdownResponse } from '../models';

const baseUrl = '/api/Admin/Search';

export const SearchAPI = {
  
  async fetchCompanies(term: string, count?: number): Promise<IDropdownResponse[]> {
    try {
      const response: AxiosResponse<IDropdownResponse[]> = await authFetch.get(`${baseUrl}/companies/drop-down`, { term, count });
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
};
